import type {
  FilterConditionDto,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdCondition
} from '@bindoc-projects/condition-domain-lib';

import type {
  FilterConditionPluginSpecification,
  FilterDetailedText,
} from '@bindoc-projects/filter-condition-domain-lib';
import {
  FilterConditionPluginImpl
} from '@bindoc-projects/filter-condition-domain-lib';

export const OP_NOTFALLEINGRIFF_CONDITION_ID =
  'intuitiveOpNotfalleingriff';
export const FilterConditionOpNotfalleingriffPluginType: FilterConditionPluginSpecification<
  boolean,
  FilterConditionOpNotfalleingriffDto,
  BdOpNotfalleingriffCondition
> = {
  type: 'intuitiveOpNotfalleingriff',
  category: 'case',
  displayName: { de: 'Notfalleingriff' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionOpNotfalleingriffDto,
  ): FilterConditionPluginImpl<boolean> {
    return new FilterConditionOpNotfalleingriffPlugin(obj.flag);
  },
  fromCondition(
    jsonObj: BdOpNotfalleingriffCondition,
  ): FilterConditionPluginImpl<boolean> {
    return new FilterConditionOpNotfalleingriffPlugin(jsonObj.flag);
  },
  newInstance(): FilterConditionPluginImpl<boolean> {
    return new FilterConditionOpNotfalleingriffPlugin(true);
  },
};

export class FilterConditionOpNotfalleingriffPlugin extends FilterConditionPluginImpl<
  boolean,
  FilterConditionOpNotfalleingriffDto
> {
  static override Specification: FilterConditionPluginSpecification<
    boolean,
    FilterConditionOpNotfalleingriffDto,
    BdOpNotfalleingriffCondition
  > = FilterConditionOpNotfalleingriffPluginType;

  constructor(private _flag: boolean) {
    super(FilterConditionOpNotfalleingriffPluginType.type);
  }

  toCondition(): BdCondition {
    return new BdOpNotfalleingriffCondition(this._flag);
  }

  toJSON(): FilterConditionOpNotfalleingriffDto | null {
    return {
      type: this.type,
      flag: this._flag,
    };
  }

  toText(): string | null {
    return 'Notfalleingriff';
  }

  override toDetailedText(): FilterDetailedText | null {
    const title = this.toText();
    if (!title) return null;
    if (this._flag === null || this._flag === undefined) return { title, items: [] };
    return { title, items: [this._flag ? 'Ja' : 'Nein'] };
  }

  toValue(): boolean {
    return this._flag;
  }

  override equals(
    other: FilterConditionOpNotfalleingriffPlugin,
  ): boolean {
    return super.equals(other) && this._flag === other._flag;
  }

  override valid(): boolean {
    return this._flag !== null && this._flag !== undefined;
  }

  override validationToText(): string {
    if (this.valid()) {
      return '';
    } else {
      return 'Ja/Nein auswählen';
    }
  }

  clone(): FilterConditionOpNotfalleingriffPlugin {
    return new FilterConditionOpNotfalleingriffPlugin(this._flag);
  }
}

export class BdOpNotfalleingriffCondition extends BdCondition {
  constructor(public flag: boolean) {
    super(OP_NOTFALLEINGRIFF_CONDITION_ID);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        flag: this.flag,
      },
    };
  }
}

interface FilterConditionOpNotfalleingriffDto {
  type: string;
  flag: boolean;
}
